/** Номинал скидки промокода (руб.). */
export function promocodeDiscount(promo) {
  if (!promo) return 0;
  const raw = promo.discount ?? promo.amount;
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

/** Активный (неиспользованный) промокод события по коду. */
export function findActivePromocode(promoCodes, code) {
  const trimmed = String(code ?? '').trim();
  if (!trimmed || !Array.isArray(promoCodes)) return null;
  const found = promoCodes.find((p) => p.code === trimmed && p.isUse === false);
  return found ?? null;
}

/**
 * Итоговые цены билетов после применения промокода (по порядку выбора).
 * @returns {number[] | null} null — промокод не применён
 */
export function applyPromoDiscount(seatPrices, discountAmount) {
  if (!discountAmount || discountAmount <= 0) return null;
  let remaining = discountAmount;
  return seatPrices.map((price) => {
    const base = Math.max(0, Number(price) || 0);
    remaining -= base;
    if (remaining < 0) {
      const toPay = -remaining;
      remaining = 0;
      return toPay;
    }
    return 0;
  });
}

/** Цены к оплате для выбранных мест с учётом промокода. */
export function seatPricesWithPromo(seats, promoCodes, promocode) {
  const basePrices = (seats || []).map((s) => Math.max(0, Number(s.price) || 0));
  const promo = findActivePromocode(promoCodes, promocode);
  const discount = promocodeDiscount(promo);
  if (!promo || discount <= 0) return basePrices;
  return applyPromoDiscount(basePrices, discount);
}
